import { render, staticRenderFns } from "./nl2br.vue?vue&type=template&id=428fece4"
import script from "./nl2br.vue?vue&type=script&lang=ts"
export * from "./nl2br.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports